import { createBaseQuery } from "../helper/createBaseQuery";
import { tokenSlice } from "../slice/tokenSlice";

const groupApi = tokenSlice.injectEndpoints({
    reducerPath: 'group',
    baseQuery: createBaseQuery(),
    tagTypes: ['Group'],
    endpoints(builder) {
        return {

            // GET

            getGroups: builder.query({
                query: () => ({
                    url: `Group/GetGroups`,
                    method: 'GET',
                }),
                providesTags: ['Group'],
            }),
            getAvailableGroupsForUser: builder.query({
                query: (id) => ({
                    url: `Group/AvailableGroupsForUser?userId=${id}`,
                    method: 'GET',
                }),
                providesTags: ['Group'],
            }),
            getRoleByGroup: builder.query({
                query: (id) => ({
                    url: `Group/GetRoles/${id}`,
                    method: 'GET',
                }),
                providesTags: ['Group'],
            }),

            getGroupInfo: builder.query({
                query: (id) => ({
                    url: `Group/GetGroupInfo/${id}`,
                    method: 'GET',
                }),
                providesTags: ['Group'],
            }),


            getBuyerByGroup: builder.query({
                query: (id) => ({
                    url: `Group/GetBuyers/${id}`,
                    method: 'GET',
                }),
                providesTags: ['Group'],
            }),
            getAdditionalPrevilegesByGroup: builder.query({
                query: (id) => ({
                    url: `Group/GetAdditionalPrivileges/${id}`,
                    method: 'GET',
                }),
                providesTags: ['Group'],
            }),
            getEmailByGroup: builder.query({
                query: (id) => ({
                    url: `Group/GetEmailNotifications/${id}`,
                    method: 'GET',
                }),
                providesTags: ['Group'],
            }),
            getBusinessByGroup: builder.query({
                query: (id) => ({
                    url: `Group/GetBusinessUnits/${id}`,
                    method: 'GET',
                }),
                providesTags: ['Group'],
            }),

            getUserByGroup: builder.query({
                query: (id) => ({
                    url: `Group/GetUsers/${id}`,
                    method: 'GET',
                }),
                providesTags: ['Group'],
            }),
            getAnalysisByGroupId: builder.query({
                query: (id) => ({
                    url: `Group/GetAnalysisCodes/${id}`,
                    method: 'GET',
                }),
                providesTags: ['Group'],
            }),
            getMenuByGroupId: builder.query({
                query: (id) => ({
                    url: `Menu/GetGroupMenuWithPrivilege?groupId=${id}`,
                    method: 'GET',
                }),
                providesTags: ['Group'],
            }),

            // POST

            postSaveGroup: builder.mutation({
                query: (groupSave) => ({
                    url: 'Group/SaveGroup',
                    method: "POST",
                    body: groupSave
                }),
                invalidatesTags: ['Group']
            }),

            postDeleteGroup: builder.mutation({
                query: (deleteGroup) => ({
                    url: `Group/DeleteGroup`,
                    method: 'POST',
                    body: deleteGroup
                }),
                invalidatesTags: ['Group']
            }),
        }
    }
})

export const {
    useGetGroupsQuery,
    useGetAdditionalPrevilegesByGroupQuery,
    useGetAvailableGroupsForUserQuery,
    useGetRoleByGroupQuery,
    useGetBuyerByGroupQuery,
    useGetEmailByGroupQuery,
    useGetBusinessByGroupQuery,
    useGetUserByGroupQuery,
    useGetAnalysisByGroupIdQuery,
    useGetMenuByGroupIdQuery,
    usePostSaveGroupMutation,
    usePostDeleteGroupMutation,
    useGetGroupInfoQuery
} = groupApi;
export { groupApi };